import { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

export { SituationPage as default } from '@/components/enpages/Ir/Stock/Situation'

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()

  const stockSituation = await client.fetchStockSituation();
  const stockSituationOwnership = await client.fetchStockSituationOwnership();
  const stockSituationPrincipal = await client.fetchStockSituationPrincipal();
  
  return {
    props: {
      stockSituation,
      stockSituationOwnership,
      stockSituationPrincipal
    },
  }
}
